// @flow
import * as React from 'react';
import NewsArticleFeaturedArticles from './Internal/FeaturedArticles';
import NewsArticleSocial from './Internal/Social';
import NewsArticleTitle from './Internal/Title';

import type { TitleType } from './Internal/Title';
import type { ArticleType as FeaturedArticleType } from './Internal/FeaturedArticles';

import ImageComponent from '../../components/Image';
import VideoComponent from '../../components/Video';
import StructuredDataArticle from './Internal/StructuredDataArticle';

type ImageType = {|
  image: string,
  alt: string,
  caption?: string,
|};

type VideoType = {|
  embeddedId: string,
  videoTitle?: string,
  videoIntro?: string,
|};

type DefaultBlogFeature = ImageType | VideoType;

type NewsArticlePropsType = {|
  ...TitleType,
  ...DefaultBlogFeature,
  linkedInUrl: string,
  emailUrl: string,
  twitterUrl: string,
  facebookUrl: string,
  children: React.Node,
  featuredArticles: Array<FeaturedArticleType>,
|};

const NewsArticle = (props: NewsArticlePropsType) => {
  return (
    <>
      <article>
        <NewsArticleTitle
          title={props.title}
          intro={props.intro}
          author={props.author}
          date={props.date}
          categories={props.categories}
        />
        <div style={{ position: 'relative' }}>
          <NewsArticleSocial
            emailUrl={props.emailUrl}
            linkedInUrl={props.linkedInUrl}
            twitterUrl={props.twitterUrl}
            facebookUrl={props.facebookUrl}
          />
          {props.image && (
            <ImageComponent image={props.image} alt={props.alt} caption={props.caption} />
          )}
          {props.embeddedId && (
            <VideoComponent
              wistiaId={props.embeddedId}
              title={props.videoTitle}
              intro={props.videoIntro}
            />
          )}

          {props.children}
        </div>
        <StructuredDataArticle />
      </article>
      {props.featuredArticles.length > 0 && (
        <NewsArticleFeaturedArticles articles={props.featuredArticles} />
      )}
    </>
  );
};

export { NewsArticleFeaturedArticles, NewsArticleSocial, NewsArticleTitle, NewsArticle };
